module.exports = __webpack_public_path__ + "static/img/bg-5.25c9bdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-5.png
// module id = NGBt
// module chunks = 0